import { useMutation } from '@tanstack/react-query';

import { type PointsGroup } from 'src/features/parkingManagement/types/pointsGroup';
import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { CreatePointsGroupFormSchemaValues as FormSchemaValues } from 'src/features/parkingManagement/api/PointsGroup/useCreatePointsGroup';

const RESOURCE = '/parkings/:parkingId/points-group/:pointsGroupId/';

interface DTO extends FormSchemaValues {
    parkingId: string;
    pointsGroupId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, pointsGroupId, ...data }: DTO): Promise<PointsGroup> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, pointsGroupId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdatePointsGroup };
